import { render, staticRenderFns } from "./EmployeeBranchDetail.vue?vue&type=template&id=2357bcbd&"
import script from "./EmployeeBranchDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports